import React from "react";
import styled from "styled-components";
import { Row } from "@ui/components/layout";

interface LivecourseDateInputProps extends React.HTMLAttributes<HTMLDivElement> {
	value: string;
}
export const LivecourseDateInput: React.FC<LivecourseDateInputProps> = ({ value, ...htmlProps }) => {
	return (
		<Container {...htmlProps}>
			<Row gap={4} align="center">
				{value}
			</Row>
		</Container>
	);
};

const Container = styled.div`
	background-color: ${({ theme }) => theme.colors.simplegray};
	border-radius: 5px;
	border: 1px solid ${({ theme }) => theme.colors.secondaryLight};
	padding: 9px 12px 7px;
	${({ theme }) => theme.textStyles.label};
	color: ${({ theme }) => theme.colors.textPrimary};
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	width: auto;
`;
